import type { RouteRecordRaw } from 'vue-router';
import { buildChildURL } from '@centric-os/helpers';
import { ReportsRouteNames, ReportsRoutePathNames } from '../enums';

const ReportingDiagnostics = () =>
  import('../components/reporting-diagnostics/ReportingDiagnostics.vue');

const reportingDiagnosticsRoute = {
  path: buildChildURL(ReportsRoutePathNames.REPORTING_DIAGNOSTICS),
  name: ReportsRouteNames.REPORTING_DIAGNOSTICS,
  component: ReportingDiagnostics,
} as RouteRecordRaw;

const Refunds = () => import('../components/refunds/Refunds.vue');

const refundsRoute = {
  path: buildChildURL(ReportsRoutePathNames.REFUND),
  name: ReportsRouteNames.REFUND,
  component: Refunds,
} as RouteRecordRaw;

const SalesDistribution = () => import('../components/sales-distribution/SalesDistribution.vue');

const salesDistributionRoute = {
  path: buildChildURL(ReportsRoutePathNames.SALES_DISTRIBUTION),
  name: ReportsRouteNames.SALES_DISTRIBUTION,
  component: SalesDistribution,
} as RouteRecordRaw;

const SalesMix = () => import('../components/sales-mix/SalesMix.vue');

const salesMixRoute = {
  path: buildChildURL(ReportsRoutePathNames.SALES_MIX),
  name: ReportsRouteNames.SALES_MIX,
  component: SalesMix,
} as RouteRecordRaw;

const SalesMix2 = () => import('../components/sales-mix-2-0/SalesMix2.vue');

const salesMix2Route = {
  path: buildChildURL(ReportsRoutePathNames.SALES_MIX_2_0),
  name: ReportsRouteNames.SALES_MIX_2_0,
  component: SalesMix2,
} as RouteRecordRaw;

const SalesSummary = () => import('../components/sales-summary/SalesSummary.vue');

const salesSummaryRoute = {
  path: buildChildURL(ReportsRoutePathNames.SALES_SUMMARY),
  name: ReportsRouteNames.SALES_SUMMARY,
  component: SalesSummary,
} as RouteRecordRaw;

const TerminalSales = () => import('../components/terminal-sales/TerminalSales.vue');

const terminalSalesRoute = {
  path: buildChildURL(ReportsRoutePathNames.TERMINAL_SALES),
  name: ReportsRouteNames.TERMINAL_SALES,
  component: TerminalSales,
} as RouteRecordRaw;

const Discounts = () => import('../components/discounts/Discounts.vue');

const discountsRoute = {
  path: buildChildURL(ReportsRoutePathNames.DISCOUNTS),
  name: ReportsRouteNames.DISCOUNTS,
  component: Discounts,
} as RouteRecordRaw;

const SalesReadings = () => import('../components/sales-reading/SalesReading.vue');

const salesReadingsRoute = {
  path: buildChildURL(ReportsRoutePathNames.SALES_READINGS),
  name: ReportsRouteNames.SALES_READING,
  component: SalesReadings,
} as RouteRecordRaw;

const childRoutes: RouteRecordRaw[] = [
  reportingDiagnosticsRoute,
  refundsRoute,
  salesDistributionRoute,
  salesMixRoute,
  salesMix2Route,
  salesSummaryRoute,
  terminalSalesRoute,
  discountsRoute,
  salesReadingsRoute,
];

export default childRoutes;
